import { useTheme } from "@mui/material";
import { ReceiptText } from "iconsax-react";
import React from "react";

import CollapseButton from "@SonarCX/components/atoms/CollapseButton";
import UserActivity from "./UserActivity";

import { useAppDispatch, useAppSelector } from "@SonarCX/hooks/redux";
import { useBreakpoint } from "@SonarCX/providers/BreakpointProvider";
import { loadUserActivities, selectActivity } from "@SonarCX/slices/activity";
import useStyles from "./styles";

type UserActivityProps = {
  user: APIUser;
};

const UserActivityLog: React.FC<UserActivityProps> = ({ user }) => {
  const dispatch = useAppDispatch();
  const { user: allUserActivity, loaded } = useAppSelector(selectActivity);

  const theme = useTheme();
  const { up770 } = useBreakpoint();
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(true);

  const activities = React.useMemo(() => {
    if (!loaded.includes(user.id)) {
      return [];
    }

    return allUserActivity[user.id];
  }, [loaded, user.id, allUserActivity]);

  // Loads task activities
  React.useEffect(() => {
    if (user.id) {
      dispatch(loadUserActivities(user.id));
    }
  }, [dispatch, user.id]);

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <div
          style={{
            display: "flex",
            cursor: "default",
            alignItems: "center",
            gap: 9,
          }}
        >
          <ReceiptText size={theme.size.base} variant="Bold" color="grey" />
          ACTIVITY LOG
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          {up770 && (
            <CollapseButton
              open={expanded}
              onToggle={() => setExpanded(!expanded)}
            />
          )}
        </div>
      </div>

      {expanded && (
        <div className={classes.items}>
          {activities.length === 0
            ? "No Activity Data"
            : activities.map((activity) => (
                <UserActivity key={activity.id} activity={activity} />
              ))}
        </div>
      )}
    </div>
  );
};

export default UserActivityLog;
